import { render, staticRenderFns } from "./Inside.vue?vue&type=template&id=a4a11970&scoped=true"
import script from "./Inside.vue?vue&type=script&lang=js"
export * from "./Inside.vue?vue&type=script&lang=js"
import style0 from "./Inside.vue?vue&type=style&index=0&id=a4a11970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a11970",
  null
  
)

export default component.exports